// gtm-events.js
window.dataLayer = window.dataLayer || [];

 function getParamFromURL(param, _url){
      if(!_url) _url = window.location.href;
  
      var url = new URL(_url);
      var search_params = url.searchParams;
      var paramVal = search_params.get(param);
  
      return paramVal;
}

function deleteParamFromURL(param, _url){
      if(!param) return null;
      if(!_url) _url = window.location.href;
      var url = new URL(_url);
      var search_params = url.searchParams;
      search_params.delete(param);
      var new_url = url.toString();
      return new_url;
}

function _debounce(func, wait) {
  let timeout;

  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}


class sauleeAnalytics {
    constructor() {
      this.isMobile = window.innerWidth < 768;
  
      this.lastDesktopMenuInteractionTime = 0;
  
      this.trackScroll();
      this.trackMobileMenubarInteractionV2();
      this.trackKlaviyoNewsletterSubscription();
      this.trackFooterNewsletterSubscription();
      this.trackKlaviyoBackInStockFormSubmit();
      this.trackCartQuantityChange();
      this.trackPDPYouMayAlsoLikeInteraction();
      this.trackMinicartView();
      this.trackPDPImageView();
      this.trackPDPPairProductInteraction();
    //   this.trackPDPReviewPaginationInteraction();
    //   this.trackLoginAndSignup();
    // this.trackSortByInteraction();
    //  this.trackFilterInteraction();
     this.trackHomepageBannerView();
     this.trackPLPPaginationInteraction();
     this.trackFloatingAddToCartInteraction();
    }
  
    // 25%, 50%, 75%, 100% :: Debounce 100ms
    trackScroll() {
      let lastScrollTime = Date.now();
      window.addEventListener('scroll', _debounce(() => {
        const currentTime = Date.now();
        if(currentTime - lastScrollTime < 1000) return;
        lastScrollTime = currentTime;
  
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollPercentage = (scrollPosition / (documentHeight - windowHeight)) * 100;
        let finalPercentage = 0;
        
        if (scrollPercentage >= 25 && scrollPercentage < 50) {
          finalPercentage = 25;
        }
        if (scrollPercentage >= 50 && scrollPercentage < 75) {
          finalPercentage = 50;
        }
        if (scrollPercentage >= 75 && scrollPercentage < 100) {
          finalPercentage = 75;
        }
        if (scrollPercentage >= 90) {
          finalPercentage = 90;
        }
  
        if(finalPercentage > 0) {
          Shopify.analytics.publish('on_page_scroll', {
            scroll_percent: finalPercentage,
          });
        }
      }, 1000));
    }
  
    // Track desktop menubar interaction v3 :: track clicks :: Global
    trackDesktopMainMenuInteraction(mainMenuTitle, subMenuTitle = '', interectionTime) {
      if(!mainMenuTitle) return;
  
      if(interectionTime - this.lastDesktopMenuInteractionTime < 250) return;
  
      this.lastDesktopMenuInteractionTime = interectionTime;
  
      Shopify.analytics.publish('on_desktop_menubar_interaction', {
        menu_section: mainMenuTitle,
        submenu_section: subMenuTitle,
        is_mobile: this.isMobile,
      });
    }
  
    // mobile menubar interaction v2 :: event delegation :: track clicks
    trackMobileMenubarInteractionV2() {
      const mobileMenuLinks = document.querySelectorAll('.mobile-menu li a');
      if (mobileMenuLinks.length === 0) return;
  
      mobileMenuLinks.forEach(link => {
        link.addEventListener('click', (event) => {
          event.preventDefault(); // Stop for a while
  
          let parentMenuName = '', childMenuName = '';
          const megaMenuContainer = link.closest('ul.sub-menu');
          if (megaMenuContainer) {
            parentMenuName = megaMenuContainer.closest('.link-container')?.querySelector('.parent-link')?.textContent?.trim() || '';
            childMenuName = link?.textContent?.trim() || '';
          } else {
            parentMenuName = link?.textContent?.trim() || '';
            childMenuName = '';
          }
        
          Shopify.analytics.publish('on_mobile_menubar_interaction', {
            menu_section: parentMenuName,
            submenu_section: childMenuName,
          });
  
          // Redirect to the target URL after 250ms
          const targetUrl = link.href;
          if (targetUrl) {
            setTimeout(() => {
              window.location.href = targetUrl;
            }, 250);
          }
        });
      });
    }

    // track footer newsletter subscription :: form submission :: trigger on last step of form submission
    trackFooterNewsletterSubscription() {
      const footerNewsletterForm = document.querySelector('#footer form#contact_form');
      if(!footerNewsletterForm) return;

      footerNewsletterForm.addEventListener('submit', (event) => {
        event.preventDefault();
        console.log("footerNewsletterForm==>", event);
        Shopify.analytics.publish('on_footer_newsletter_subscription', {
          email: footerNewsletterForm.querySelector('input[name="contact[email]"]').value,
        });
      });
    }
  
    // track klaviyo newsletter subscription :: form submission :: trigger on last step of form submission
    // Steps: 1. stepSubmit, 2. submit, 3. viewedStep
    trackKlaviyoNewsletterSubscription() {
      let stepEvents = {
        Email: false,
      };
  
      window.addEventListener("klaviyoForms", function(e) { 
        console.log("Klaviyo Form Event==>", e);
        if(e?.detail?.type === "stepSubmit") {
          if(e?.detail?.metaData?.$step_name.includes("Email")) {
            stepEvents.Email = true;
          }
        }
  
        if(e?.detail?.type === "submit") {
          const body = document.querySelector('body');
          if(body.classList.contains('sticky-newsletter-form-active')) {
            Shopify.analytics.publish('on_sticky_newsletter_form_interaction', {
              email: e?.detail?.metaData?.$email || '', // get email from form data
            });
          } else {
            if(stepEvents.Email) {
              Shopify.analytics.publish('on_newsletter_subscribe', {
                email: e?.detail?.metaData?.$email || '', // get email from form data
              });
            }
          }
        }
      });
    }


    trackKlaviyoBackInStockFormSubmit() {
    window.addEventListener("klaviyoForms", function(e) { 
        console.log("Klaviyo Form Event==>", e);
        if(e?.detail?.type === "submitBackInStockForm") {
          // Shopify.analytics.publish('on_out_of_stock_notification');
          Shopify.analytics.publish('on_back_in_stock_form_submit', {
            email: e?.detail?.metaData?.$email || '', // get email from form datatitle from form data
            product_title: window._theme?.productJson?.title || '', // get product title from form data
          });
        }
    });
    }

  
    // Track PLP Sort By Interaction
    trackSortByInteraction(value) {
      Shopify.analytics.publish('on_plp_filter_sort_by_interaction', {
        type: 'sort_by',
        plp_section: "Sort By",
        plp_subsection: value,
        is_mobile: this.isMobile,
      });
    }


    trackPDPSelectedVariantOptionInteraction(name, value) {
      Shopify.analytics.publish('on_pdp_selected_variant_interaction', {
        option_name: name,
        option_value: value,
      });
    }
  
    // Track PLP Filter Interaction
    trackFilterInteraction(parentFilterName, childFilterName, isFilterDrawer) {
      if(!parentFilterName) return;
  
      if(isFilterDrawer) {
        Shopify.analytics.publish('on_plp_filter_sort_by_interaction', {
          type: 'filter',
          plp_section: parentFilterName,
          plp_subsection: childFilterName,
          is_mobile: this.isMobile,
        });
      } else {
        Shopify.analytics.publish('on_plp_filter_sort_by_interaction', {
          type: 'sub_collection',
          plp_section: "Sub collection",
          plp_subsection: childFilterName,
          is_mobile: this.isMobile,
        });
      }
    }
  
    // Track PLP Sub-collection & Pagination Interaction
    trackPLPPaginationInteraction() {
      const collectionPage = document.querySelector('body.template-collection');
      if(!collectionPage) return;
  
      const loadMoreButton = collectionPage.querySelector('.load-more');
      if(loadMoreButton) {
        loadMoreButton.addEventListener('click', () => {
          const currentPage = loadMoreButton.getAttribute('data-current-page');
          Shopify.analytics.publish('on_plp_pagination_interaction', {
            type: 'pagination',
            plp_section: "Pagination",
            plp_subsection: currentPage,
            is_mobile: this.isMobile,
          });
        });
      }
      
      // Also track when pagination loads new products (for infinite scroll or load more)
      document.addEventListener('pagination:page-changed', (event) => {
        const url = event.detail?.url || '';
        const pageNumber = url.split('page=')[1] || '';
        
        if(pageNumber) {
          Shopify.analytics.publish('on_plp_pagination_interaction', {
            type: 'pagination',
            plp_section: "Pagination",
            plp_subsection: pageNumber,
            is_mobile: this.isMobile,
          });
        }
      });
      
    }
  
    // Track cart quantity change
    trackCartQuantityChange() {
      // Side cart quantity change
      document.addEventListener('cart:quantity.cart-cart-drawer', evt => {
        Shopify.analytics.publish('on_cart_quantity_change', {
          product_name: evt.detail[2]?.closest('.cart__item-details')?.querySelector('.cart__item-name')?.textContent?.trim(),
          product_quantity: evt.detail[1],
        });
      });
  
      // Cart page quantity change
      document.addEventListener('cart:quantity.cart-page', evt => {
        Shopify.analytics.publish('on_cart_quantity_change', {
          product_name: evt.detail[2]?.closest('.cart__item-details')?.querySelector('.cart__item-name')?.textContent?.trim(),
          product_quantity: evt.detail[1],
        });
      });
    }

     // Track PDP "You may also like" interaction

      // Track PDP "You may also like" interaction
  trackPDPYouMayAlsoLikeInteraction() {
    const youMayAlsoLike = document.querySelector('body.template-product product-recommendations.product-recommendations');
    if (!youMayAlsoLike || !window._theme?.productJson) return;

    let isProcessing = false;

    youMayAlsoLike.addEventListener('click', (event) => {      
     
      // Check if clicked element is a title link or product image (or inside a product card link)
      const isProductTitle = event.target.classList.contains('product-card-title');
      const isProductImage = event.target.classList.contains('product-secondary-image');
      const isProductCardLink = event.target.closest('.product-card--featured-image-link');
      
      if (!isProductTitle && !isProductImage && !isProductCardLink) return;

      // Prevent multiple simultaneous clicks
      if (isProcessing) return;
      isProcessing = true;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      console.log("eventYMAL==>", event);
     
      

      // Get product title - if clicked on title link, use its text; otherwise find the title in the card
      let productTitle = '';
      if (event.target.classList.contains('product-card-title')) {
        productTitle = event.target.textContent?.trim() || '';
      } else {
        productTitle = event.target.closest('.product-card')?.querySelector('.product-card-title')?.textContent?.trim() || '';
      }

      // Get target URL
      let targetUrl = '';
      if(event.target.classList.contains('product-secondary-image')) {
        targetUrl = event.target.closest('.product-card--featured-image-link')?.getAttribute('href') || '';
      } else if (event.target.classList.contains('product-card-title')) {
        targetUrl = event.target.href || '';
      } else if (event.target.closest('.product-card--featured-image-link')) {
        targetUrl = event.target.closest('.product-card--featured-image-link').getAttribute('href') || '';
      }

      // Publish analytics event
      Shopify.analytics.publish('on_pdp_you_may_also_like_interaction', {
        from_sku: window._theme?.productJson?.title,
        to_sku: productTitle,      
      });

      // Redirect to the target URL after 250ms
      if (targetUrl) {
        setTimeout(() => {
          window.location.href = targetUrl;
        }, 250);
      } else {
        // Reset flag if no URL found
        isProcessing = false;
      }
    });
  }

  // Track Minicart View
  trackMinicartView() {
    const cartDrawerButton = document.querySelector('.thb-secondary-area-item.thb-secondary-cart');
    const miniCartWrapper = document.querySelector('#Cart-Drawer');
    
    if (!cartDrawerButton ) return;

    cartDrawerButton.addEventListener('click', () => {
      if (miniCartWrapper.classList.contains('active')) { 
        if (!window.cartState || !window.cartState.items || window.cartState.items.length === 0) {
          return;
        }
    
        const items = window.cartState.items.map((item, index) => ({
          index: index,
          item_id: item.sku || item.variantId,
          product_id: item.productId,
          variant_id: item.variantId,
          item_name: item.name + (item.sku ? ` - ${item.sku}` : ''),
          price: item.price,
          quantity: item.quantity,
          item_brand: item.vendor || '',
          item_category: item.product_type || '',
          item_variant: item.variant_title !== 'Default Title' ? item.variant_title : undefined,
          sku: item.sku
        }));

        Shopify.analytics.publish('on_minicart_view', {
          event: "view_cart_drawer",
          ecommerce: {
            currency: window.cartState.currency,
            value: window.cartState.totalValue,
            items: items
          }
        });
      }
    });
  }

  
  // Track PDPimage view
  trackPDPImageView() {
    const pdpImageZoomButton = document.querySelectorAll('.product-image-container .product-single__media-zoom');
    const pdpzoomWrapper = document.querySelector('.pswp.no-js-hidden');
    
    if (!pdpImageZoomButton ) return;

    pdpImageZoomButton.forEach(button => {
      button.addEventListener('click', () => {
      if (pdpzoomWrapper.classList.contains('pswp--open')) { 
        Shopify.analytics.publish('on_image_view', {
          event: "view_image",
          from_sku: window._theme?.productJson?.title,
        });
        }
      });
    });
  }

  // Track PDP  pair product interaction
  trackPDPPairProductInteraction() {
    const pairProduct = document.querySelector('body.template-product product-recommendations.complementary-products');

    if (!pairProduct || !window._theme?.productJson) return;

    pairProduct.addEventListener('click', (event) => {
      console.log("eventPairProduct==>", event.target);
      const quickViewButton = event.target.innerHTML.includes('Quick view');
      const cartProductLink = event.target.classList.contains('cart-product-link') || event.target.closest('.cart-product-link');
      
      if(quickViewButton || cartProductLink) {
        const productTitle = event.target.closest('.product-cart-item')?.querySelector('.cart-product-link')?.textContent?.trim() || '';

        Shopify.analytics.publish('on_pdp_pair_product_interaction', {
          from_sku: window._theme?.productJson?.title,
          to_sku: productTitle,  
        });
      }
    });
  }


  // Track Homepage Hero Banner View
  trackHomepageBannerView() {
    const banners = document.querySelectorAll("[data-viewport='desktop-only'] .slideshow__slide a.text-button");
    if (!banners) return;

    // Track which banners have been viewed to prevent duplicates
    const viewedBanners = new Set();

    banners.forEach((banner) => {
      // Track clicks
      banner.addEventListener("click", (event) => {
        event.preventDefault(); // Prevent default navigation temporarily
        
        const targetUrl = banner.href;
        
        // Track the banner click
        trackBannerView('banner_click', banner);
        
        // Navigate to the target URL after 250ms
        if (targetUrl) {
          setTimeout(() => {
            window.location.href = targetUrl;
          }, 250);
        }
      });

      // Track visible banners only
      const slide = banner.closest(".slideshow__slide");
      if (!slide) return;

      // Get unique identifier for this banner
      const bannerId = banner.getAttribute("data-banner-name") || "unknown_banner";

      // Check if banner is currently visible
      if (slide.classList.contains("is-selected") && !viewedBanners.has(bannerId)) {
        trackBannerView('banner_view', banner);
        viewedBanners.add(bannerId);
      }

      // Observe if the banner becomes active later
      const observer = new MutationObserver(() => {
        if (slide.classList.contains("is-selected") && !viewedBanners.has(bannerId)) {
          trackBannerView('banner_view', banner);
          viewedBanners.add(bannerId);
          observer.disconnect(); // stop observing once tracked
        }
      });

      observer.observe(slide, { attributes: true, attributeFilter: ["class"] });
    });

    function trackBannerView(eventName, banner) {
      if(!banner) return;
  
      const bannerName = banner.getAttribute("data-banner-name") || "unknown_banner";
      const bannerPosition = banner.getAttribute("data-banner-position") || "";
      Shopify.analytics.publish(eventName, {
        banner_name: bannerName,
        banner_position: bannerPosition,
      });
    }
  }


  // Track Floating Add To Cart Interaction
  // trackFloatingAddToCartInteraction() {
    
  //   const floatingAddToCart = document.querySelector('product-add-to-cart-sticky');
  //   if (!floatingAddToCart) return;

  //   floatingAddToCart.addEventListener('click', (event) => {
  //     console.log("floatingAddToCart==>", event.target);
  //     const addToCartButton = event.target.closest('.product-add-to-cart-sticky--inner');
  //     if(addToCartButton) {
  //       Shopify.analytics.publish('on_floating_add_to_cart_interaction', {
  //         event: "add_to_cart",
  //       });
  //     }
  //   });
  // }


  // Track Floating Add To Cart Interaction
trackFloatingAddToCartInteraction() {

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.single-add-to-cart-button');
    if (!btn) return;
  
    // Check if clicked button is floating (sticky) Add to Cart
    const isFloating = btn.id === 'AddToCartSticky';

    console.log("isFloating==>", isFloating);
  
    // Publish custom event with type info
    Shopify.analytics.publish('on_floating_add_to_cart_interaction', {
      event: isFloating ? 'floating_add_to_cart' : 'add_to_cart',
    });
  });
}
//   let lastClickedButton = null;

//   // STEP 1: Detect which Add to Cart button was clicked
//   document.addEventListener('click', (e) => {
//     console.log("e==>", e);
//     const btn = e.target.classList.contains('single-add-to-cart-button');
//     console.log("btn==>", btn);
//     if (btn && btn.id === 'AddToCartSticky') {
//       lastClickedButton = 'floating';
//     }
//   });

//   // STEP 2: Subscribe to the Shopify analytics event
//   analytics.subscribe('product_added_to_cart', (event) => {
//     console.log("event==>", event);
//     const customEventName =
//       lastClickedButton === 'floating' ? 'floating_add_to_cart' : 'add_to_cart';

//     // Call your shared tracking function
//     triggerAddToCartEvent(event, customEventName);

//     // Reset after sending to avoid wrong tagging next time
//     lastClickedButton = null;
//   });

//   // STEP 3: (Optional) Manually trigger Shopify event when floating button clicked
//   const floatingAddToCart = document.querySelector('#AddToCartSticky');
//   if (floatingAddToCart) {
//     // floatingAddToCart.addEventListener('click', (event) => {
//     //   console.log('Floating Add To Cart clicked:', event.target);

//     //   // You can also publish a custom internal Shopify event
//     //   Shopify.analytics.publish('on_floating_add_to_cart_interaction', {
//     //     event: 'floating_add_to_cart',
//     //   });
//     // });

//     Shopify.analytics.publish('on_floating_add_to_cart_interaction', {
//       event: "floating_add_to_cart",
//     });
//   } else {
//     Shopify.analytics.publish('on_floating_add_to_cart_interaction', {
//       event: "add_to_cart",
//     });
//   }

  
// }



  
  }

  


  document.addEventListener("DOMContentLoaded", function () {
    window.sauleeAnalytics = new sauleeAnalytics();

   const stickyNewsletterButtonSelector = '.stickynewsletterformbutton';
   document.addEventListener('click', (event) => {
    console.log("event==>", event);
     const clickedStickyNewsletterButton = event.target.closest('[data-testid="animated-teaser"]');
     if (!clickedStickyNewsletterButton) return;
     document.body.classList.add('sticky-newsletter-form-active');
     // if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
     //   Shopify.analytics.publish('on_sticky_newsletter_form_interaction', {
     //     event: 'sticky_newsletter_form_interaction',
     //   });
     // }
   });


    // --- STEP 1: Track click source



    /* ----------------------- Cart Tracking -------------------------*/
  // Fixed cart tracking - prevents duplicate events and ensures data exists
  let cartViewTracked = false; // Prevent duplicate events

  // Cart state management
  function refreshCartState() {
    return fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        window.cartState = {
          totalItems: cart.item_count,
          totalValue: cart.total_price / 100,
          currency: cart.currency,
          items: cart.items.map(item => ({
            variantId: String(item.variant_id),
            productId: String(item.product_id),
            name: item.product_title,
            price: item.price / 100,
            quantity: item.quantity,
            sku: item.sku,
            vendor: item.vendor,
            product_type: item.product_type,
            variant_title: item.variant_title
          }))
        };
        
        return window.cartState;
      })
      .catch(err => {
        return null;
      });
  }

  // Cart view tracking function
  function trackCartView() {
    // Prevent duplicate tracking
    if (cartViewTracked) {
      return;
    }

    if (!window.cartState || !window.cartState.items || window.cartState.items.length === 0) {
      return;
    }

    const items = window.cartState.items.map((item, index) => ({
      index: index,
      item_id: item.sku || item.variantId,
      product_id: item.productId,
      variant_id: item.variantId,
      item_name: item.name + (item.sku ? ` - ${item.sku}` : ''),
      price: item.price,
      quantity: item.quantity,
      item_brand: item.vendor || '',
      item_category: item.product_type || '',
      item_variant: item.variant_title !== 'Default Title' ? item.variant_title : undefined,
      sku: item.sku
    }));

    Shopify.analytics.publish('on_sidecart_view', {
      event: "view_cart",
      ecommerce: {
        currency: window.cartState.currency,
        value: window.cartState.totalValue,
        items: items
      }
    });

    // window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //   event: "view_cart",
    //   ecommerce: {
    //     currency: window.cartState.currency,
    //     value: window.cartState.totalValue,
    //     items: items
    //   }
    // });

    cartViewTracked = true;

    // Reset the flag after 2 seconds to allow tracking again
    setTimeout(() => {
      cartViewTracked = false;
    }, 2000);
  }

  // Listen to your theme's drawer events
  document.addEventListener('drawerOpen', function(event) {
    // Check if it's the cart drawer by looking for cart-related elements
    setTimeout(() => {
      const cartDrawer = document.querySelector('.cart-drawer.active .product-cart-item--container, .cart-drawer.active  [data-cart-total]');
      if (cartDrawer) {
        // Refresh cart state first, then track
        refreshCartState().then(() => {
          trackCartView();
        });
      }
    }, 100);
  });

  // Cart removal tracking
  document.addEventListener("click", function (e) {
    return;
    const removeBtn = e.target.closest(".product-cart-item-info a.remove");
    const minusBtn = e.target.closest(".minus");

    if (!removeBtn && !minusBtn) return;

    let variantId = removeBtn.getAttribute("data-variant-id") || 
     removeBtn.closest('.product-cart-item-info')?.getAttribute("data-variant-id");

    if (!variantId) {
      const cartItem = e.target.closest(".product-cart-item");
      const variantInput = cartItem?.querySelector("input.qty");
      variantId = variantInput?.getAttribute("data-id")?.split(":")[0] || "";
    }

    if (!variantId) return;

    const cartItemData = window.cartState?.items?.find(item => item.variantId == variantId);

    if (!cartItemData) {
      // Try to refresh cart state and retry
      refreshCartState().then(() => {
        const retryItemData = window.cartState?.items?.find(item => item.variantId == variantId);
        if (retryItemData) {
          pushRemovalEvent(retryItemData, removeBtn);
        }
      });
      return;
    }

    pushRemovalEvent(cartItemData, removeBtn);
  });

  // Helper function for removal event
  function pushRemovalEvent(cartItemData, isCompleteRemoval) {
    const removedQuantity = isCompleteRemoval ? cartItemData.quantity : 1;

    const removedItem = {
      item_id: cartItemData.sku || cartItemData.variantId,
      product_id: cartItemData.productId,
      variant_id: cartItemData.variantId,
      item_name: cartItemData.name + (cartItemData.sku ? ` - ${cartItemData.sku}` : ''),
      price: cartItemData.price,
      quantity: removedQuantity,
      item_brand: cartItemData.vendor || '',
      item_category: cartItemData.product_type || '',
      item_variant: cartItemData.variant_title !== 'Default Title' ? cartItemData.variant_title : undefined,
      sku: cartItemData.sku
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "remove_from_cart",
      ecommerce: {
        currency: "INR",
        value: cartItemData.price * removedQuantity,
        items: [removedItem]
      }
    });
  }

  // Initialize cart state on page load
  refreshCartState();

  // Update cart state when cart changes (for themes that dispatch custom events)
  document.addEventListener('cart:updated', refreshCartState);
  document.addEventListener('cart:refresh', refreshCartState);



  // custom event for sort by
  document.addEventListener('sort-by:change', (event) => {
    console.log("sort-by:change==>", event);
    const sortByValue = event.detail?.value || event.detail?.sort_by || 'sort_by';
    window.sauleeAnalytics.trackSortByInteraction(sortByValue);
  });

  // custom event for filter
  document.addEventListener('filter:change', (event) => {
    console.log("filter:change==>", event);
    
    const filterData = event.detail || {};
    const filterName = filterData.filter_name || 'Unknown Filter';
    const filterValue = filterData.filter_value || '';
    const isMobile = filterData.is_mobile || false;
    const isChecked = filterData.checked;
    
    // Track filter interaction using existing method
    window.sauleeAnalytics.trackFilterInteraction(filterName, filterValue, true);
    
    // Send to data layer for GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'filter_interaction',
      filter_type: 'filter_by',
      filter_name: filterName,
      filter_value: filterValue,
      filter_action: isChecked ? 'applied' : 'removed',
      is_mobile: isMobile,
      page_type: 'collection'
    });
  });

  // Track variant option interactions (color, size, etc.)
  document.addEventListener('click', (event) => {
    // 1. Check for product siblings (links to different products)
    const siblingLink = event.target.closest('.variations.variations--siblings a');
    if (siblingLink) {
      event.preventDefault(); // Stop navigation temporarily
      
      const fieldset = siblingLink.closest('.variations.variations--siblings')?.querySelector('fieldset');
      const optionName = fieldset?.querySelector('div.form__label')?.textContent?.split(':')[0]?.trim();
      // const optionValue = siblingLink.getAttribute('title') || siblingLink.closest('label')?.textContent?.trim();
      // const optionValue = fieldset?.querySelector('div.form__label')?.textContent?.split(':')[1]?.trim();
      const optionValue = siblingLink.getAttribute('data-color');
      
      console.log("Product sibling clicked:", { optionName, optionValue });
      window.sauleeAnalytics.trackPDPSelectedVariantOptionInteraction(optionName, optionValue);
      
      // Navigate after tracking
      const targetUrl = siblingLink.href;
      if (targetUrl) {
        setTimeout(() => {
          window.location.href = targetUrl;
        }, 250);
      }
      return;
    }
    
    // 2. Check for regular variant options (radio inputs with labels)
    const variantLabel = event.target.closest('fieldset.product-form__input label');
    if (variantLabel) {
      const fieldset = variantLabel.closest('fieldset.product-form__input');
      const formLabel = fieldset?.querySelector('div.form__label');
      
      // Extract option name (before the colon)
      const optionName = formLabel?.textContent?.split(':')[0]?.trim();
      
      // Extract option value from the label text or associated input
      let optionValue = variantLabel.querySelector('span')?.textContent?.trim() || variantLabel.textContent?.trim();
      
      // Alternative: get value from associated radio input
      if (!optionValue) {
        const inputId = variantLabel.getAttribute('for');
        const input = document.getElementById(inputId);
        optionValue = input?.value;
      }
      
      console.log("Variant option clicked:", { optionName, optionValue });
      
      if (optionName && optionValue) {
        window.sauleeAnalytics.trackPDPSelectedVariantOptionInteraction(optionName, optionValue);
      }
    }
  });

  document.querySelector('shop-pay-wallet-button')?.addEventListener('click', (event) => {
    console.log('click==>', event);
    Shopify.analytics.publish('begin_checkout');
  });
  
});